import { render, staticRenderFns } from "./TabRatio.vue?vue&type=template&id=31e32274&"
import script from "./TabRatio.vue?vue&type=script&lang=js&"
export * from "./TabRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports